export const CarouselDesktopProps = {
    slidesToShow: 6,
    cellSpacing: 24,
    withoutControls: false,
    frameOverflow: "hidden",
    slideWidth: 1.0,
};

export const CarouselTabletProps = {
    slidesToShow: 4,
    cellSpacing: 20,
    withoutControls: false,
    frameOverflow: "hidden",
    slideWidth: 1.0,
};

export const CarouselMobileProps = {
    slidesToShow: 2,
    cellSpacing: 8,
    withoutControls: true,
    frameOverflow: "hidden",
    slideWidth: 0.9,
};
